var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 100,
    viewBox: "0 0 60 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_21326",
    "data-name": "\\uC0AC\\uAC01\\uD615 21326",
    width: 59.778,
    height: 100,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_48533",
    "data-name": "\\uADF8\\uB8F9 48533",
    transform: "translate(-995 -8534)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_21327",
    "data-name": "\\uC0AC\\uAC01\\uD615 21327",
    width: 60,
    height: 100,
    transform: "translate(995 8534)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_48532",
    "data-name": "\\uADF8\\uB8F9 48532",
    transform: "translate(995 8534.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_48531",
    "data-name": "\\uADF8\\uB8F9 48531",
    transform: "translate(0 -0.003)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_8661",
    "data-name": "\\uD328\\uC2A4 8661",
    d: "M83.836,996.929c.1,0,.155.053.155.187s-.053.181-.155.181H81.851v1.254c0,.128-.069.176-.2.176s-.2-.048-.2-.176V997.3H79.444c-.1,0-.149-.053-.149-.181s.053-.187.149-.187Zm-3.111-.64a1.145,1.145,0,1,1,0-2.289h1.83a1.145,1.145,0,1,1,0,2.289Zm.021-1.927a.782.782,0,1,0,0,1.564h1.788a.782.782,0,1,0,0-1.564Z",
    transform: "translate(-71.695 -898.727)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_8662",
    "data-name": "\\uD328\\uC2A4 8662",
    d: "M185.944,997.1a.162.162,0,0,1-.187-.187v-2.1c0-.133.053-.187.181-.187h2.172v-1.681h-2.2c-.1,0-.155-.059-.155-.181s.053-.181.155-.181h2.4c.128,0,.187.053.187.181v2.023c0,.133-.053.192-.176.192h-2.172v1.761h2.492c.1,0,.155.059.155.181s-.053.182-.155.182Zm3.65-.011v-4.472c0-.123.064-.176.192-.176s.2.053.2.176v4.472c0,.123-.064.176-.2.176s-.192-.054-.192-.176",
    transform: "translate(-167.953 -897.317)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_8663",
    "data-name": "\\uD328\\uC2A4 8663",
    d: "M288.252,997.082c-.1,0-.155-.053-.155-.187s.059-.181.155-.181h3.415c.1,0,.155.053.155.181s-.059.187-.155.187Zm.144-2.674v-.667c0-.854.678-1.211,1.441-1.211s1.446.357,1.446,1.211v.667c0,.859-.688,1.211-1.446,1.211s-1.441-.352-1.441-1.211m2.492-.021v-.624c0-.619-.5-.87-1.051-.87s-1.046.251-1.046.87v.624c0,.619.5.87,1.046.87s1.051-.251,1.051-.87m1.291,2.7v-4.472c0-.123.069-.176.2-.176s.2.053.2.176v4.472c0,.123-.064.176-.2.176s-.2-.054-.2-.176",
    transform: "translate(-260.484 -897.317)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_8664",
    "data-name": "\\uD328\\uC2A4 8664",
    d: "M394.836,994.163v-.587c0-.715.651-1.051,1.457-1.051s1.468.336,1.468,1.051v.587c0,.71-.662,1.046-1.468,1.046s-1.457-.336-1.457-1.046m.571,3.106c-.133,0-.192-.059-.192-.192V995.8q0-.176.192-.176c.133,0,.2.059.2.176v1.1h3.453c.1,0,.15.064.15.187s-.048.187-.15.187Zm1.953-3.149v-.507c0-.47-.448-.731-1.067-.731s-1.062.262-1.062.731v.507c0,.475.448.731,1.062.731s1.067-.256,1.067-.731m1.345,1.622v-3.127c0-.128.069-.176.2-.176s.2.048.2.176v3.127c0,.128-.059.176-.2.176s-.2-.048-.2-.176",
    transform: "translate(-356.992 -897.317)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_8665",
    "data-name": "\\uD328\\uC2A4 8665",
    d: "M502,994.526a1.3,1.3,0,0,1-1.329.683c-.779,0-1.382-.326-1.382-1.009v-.662c0-.683.6-1.014,1.382-1.014a1.358,1.358,0,0,1,1.286.592h1.147v-.5c0-.128.069-.176.2-.176s.2.048.2.176v3.128c0,.128-.059.176-.2.176s-.2-.048-.2-.176v-1.217Zm1.462,2.37c.1,0,.149.064.149.187s-.048.187-.149.187h-3.613c-.133,0-.187-.059-.187-.192V995.8c0-.117.059-.176.192-.176s.2.059.2.176v1.1Zm-3.778-2.743c0,.454.405.7.987.7s.987-.245.987-.7v-.571c0-.448-.416-.7-.987-.7s-.987.251-.987.7Zm3.421-.672h-1.051v.683h1.051Z",
    transform: "translate(-451.437 -897.317)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_8666",
    "data-name": "\\uD328\\uC2A4 8666",
    d: "M10.621,702.031v-6.622H1.091a1.091,1.091,0,0,1,0-2.181H22.748a1.091,1.091,0,0,1,0,2.181h-9.53v6.622a1.2,1.2,0,0,1-1.3,1.169,1.2,1.2,0,0,1-1.3-1.169M7.089,690.19c-3.35,0-5.843-2.311-5.843-5.3s2.493-5.3,5.843-5.3h9.66c3.35,0,5.843,2.311,5.843,5.3s-2.493,5.3-5.843,5.3Zm9.193-2.181c2.129,0,3.713-1.272,3.713-3.116s-1.584-3.116-3.713-3.116H7.557c-2.129,0-3.713,1.3-3.713,3.116,0,1.844,1.584,3.116,3.713,3.116Z",
    transform: "translate(0 -614.458)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_8667",
    "data-name": "\\uD328\\uC2A4 8667",
    d: "M389.334,681.827v-2.752c0-3.688,2.986-5.609,6.622-5.609,2.649,0,4.96,1.013,6.024,3.012H408.6v-1.948a1.306,1.306,0,0,1,2.6,0v15.061a1.306,1.306,0,0,1-2.6,0v-4.986h-6.726c-1.091,1.87-3.35,2.831-5.921,2.831-3.635,0-6.622-1.9-6.622-5.609m21.372,13.166a1.091,1.091,0,0,1,0,2.181H392.113a1.245,1.245,0,0,1-1.376-1.376v-5.505a1.306,1.306,0,0,1,2.6,0v4.7Zm-18.775-13.27c0,2.337,1.74,3.532,4.051,3.532,2.259,0,4-1.194,4-3.532V679.2c0-2.337-1.74-3.558-4-3.558-2.311,0-4.051,1.221-4.051,3.558Zm16.671-3.064h-6.05a2.235,2.235,0,0,1,.026.416v2.752a4.4,4.4,0,0,1-.026.6h6.05Z",
    transform: "translate(-352.018 -608.822)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_8668",
    "data-name": "\\uD328\\uC2A4 8668",
    d: "M31.316,0C14.918,0,1.578,12.664,1.578,28.233a26.974,26.974,0,0,0,1,7.3,10.483,10.483,0,0,0,9.337,7.683q.405.026.81.026a12.5,12.5,0,0,0,9-3.764l5.639,5.607a5.2,5.2,0,0,0,7.237.054l6.606-6.378A17,17,0,0,0,44.562,40.5a18.925,18.925,0,0,0,8.646.789A26.45,26.45,0,0,1,31.316,52.639a26.645,26.645,0,0,1-16.09-5.276,1.915,1.915,0,1,0-2.293,3.067,30.446,30.446,0,0,0,18.382,6.039,30.791,30.791,0,0,0,16.12-4.5,28.789,28.789,0,0,0,10.8-11.721l.283-.6a2.3,2.3,0,0,0-3.32-2.918c-2.055,1.3-7.12,1.064-9.211.223a15.509,15.509,0,0,1-1.926-.916c3.9-3.946,5.665-8.071,5.667-13.129,0,0,0-.006,0-.009,0-5.831-3.853-10.574-8.59-10.574s-8.59,4.744-8.59,10.574c0,4.757,1.966,9.208,5.848,13.257l-6.456,6.232a1.349,1.349,0,0,1-1.878-.014L22.857,35.2c-4.352-4.487-6.127-8.053-6.127-12.307,0-3.656,2.18-6.745,4.761-6.745s4.761,3.089,4.761,6.745a20.637,20.637,0,0,1-2.02,8.96A1.915,1.915,0,1,0,27.687,33.5,24.438,24.438,0,0,0,30.08,22.892c0-5.831-3.853-10.574-8.59-10.574S12.9,17.061,12.9,22.892c0,5.984,2.955,10.353,6.147,13.848a8.682,8.682,0,0,1-6.881,2.652,6.649,6.649,0,0,1-5.9-4.9,23.146,23.146,0,0,1-.86-6.261c0-13.458,11.623-24.407,25.909-24.407S57.225,14.775,57.225,28.233a1.915,1.915,0,0,0,3.829,0C61.054,12.664,47.714,0,31.316,0m9.826,16.149c2.579,0,4.759,3.086,4.76,6.74,0,0,0,0,0,0,0,4.092-1.432,7.344-4.729,10.615-3.218-3.341-4.791-6.826-4.791-10.615,0-3.656,2.18-6.745,4.761-6.745",
    transform: "translate(-1.427 0.003)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/footer_logo.a25b1c4938493bbd2fdd1ff48a937c3f.svg";
export { ForwardRef as ReactComponent };